import { ContributionAdjustmentMethod } from '../constants/contributionAdjustmentMethods';

/**
 * Guard centralizado para el evento PostHog `contribution_updated`.
 *
 * Spec: dispara cuando el usuario guarda un cambio en su aportación
 * existente (distinto de la primera configuración). Reutilizado desde:
 * - `EditContributionModalV2.handleSave` (modal grande)
 * - `MiBeneficioV2.handleQuickSave` (slider rápido)
 *
 * Reglas:
 * - `previousAmount` null/undefined → false (prop aún no cargado)
 * - `previousAmount <= 0` → false (primera configuración), salvo que el modal lo abriera el
 *   enlace del correo (Arca-Team/product#3): activar desde 0 € a raíz del correo es justo lo
 *   que se quiere medir, se quede con el importe (`preset_delta`) o lo cambie
 *   (`manual_slider`, chirigota#630). `adjustmentMethod` solo llega con el enlace, así que el
 *   resto de cambios desde 0 no cambian.
 * - `previousAmount === newAmount` → false (sin cambio efectivo)
 */
export const shouldFireContributionUpdated = (
	previousAmount: number | null | undefined,
	newAmount: number,
	adjustmentMethod?: ContributionAdjustmentMethod
): boolean => {
	if (typeof previousAmount !== 'number') return false;
	if (previousAmount <= 0 && adjustmentMethod === undefined) return false;
	return previousAmount !== newAmount;
};
